import Box from '@mui/material/Box';
import EnhancedTable, { EnhancedTableProps, EnhancedTableRow } from '#components/EnhancedTable';
import {
  formatCurrency,
} from '#common/utils';

interface SalespersonReport {
  rows: EnhancedTableRow[];
  customer: { username: string; code: string };
  subtotal: number;
}

interface SalespersonReportTableProps {
  report: SalespersonReport;
  tableProps: Omit<EnhancedTableProps, 'rows'>;
}

export default function SalespersonReportTable(props: SalespersonReportTableProps) {
  const {
    report,
    tableProps,
  } = props;

  const { rows, customer, subtotal } = report;

  return (
    <>
      <Box>
        {`${customer.username} (${customer.code})`}
      </Box>

      <EnhancedTable
        {...tableProps}
        {...{
          rows,
        }}
      />

      <Box
        sx={{
          typography: 'subtitle2',
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <b>Subtotal</b>
        :
        {' '}
        <span data-testid="subtotal">{formatCurrency(subtotal)}</span>
      </Box>
    </>
  );
}
